module.exports = __webpack_public_path__ + "img/logo_v1.a81adc73.png";